import { addDaysUtc, startOfMonthUtc, startOfWeekUtc } from "./dateUtils";
import type { CalendarFormat } from "./dateUtils";
import type { CalendarCell } from "./types";

const WEEKS = 6;
const DAYS = 7;

export interface CalendarMonthCells {
  /** Mo–So column labels, localized. */
  weekdayLabels: string[];
  /** Six Monday-first weeks (7 cells each), padded with adjacent-month days. */
  weeks: CalendarCell[][];
}

/**
 * Builds a fixed six-week month grid of pure date cells (Monday-first), padded
 * with leading/trailing days from the neighbouring months. The row count is
 * constant so the height never changes between months (clean shift animation).
 * Selection and bounds are resolved by the calendar hook, not here.
 *
 * @param month - Any date within the target month (read via UTC getters).
 * @param format - Locale-bound formatters for cell and column labels.
 */
export function buildCalendarMonth(month: Date, format: CalendarFormat): CalendarMonthCells {
  const gridStart = startOfWeekUtc(startOfMonthUtc(month));

  const weeks = Array.from({ length: WEEKS }, (_, week) =>
    Array.from({ length: DAYS }, (_, day) => format.toCell(addDaysUtc(gridStart, week * DAYS + day))),
  );

  return { weekdayLabels: format.weekdayLabels(gridStart), weeks };
}
